import { useEffect, useState } from 'react';
import styles from './OverviewForm.module.scss';
import { SllLesson } from '@src/api/graphql-codegen';
import { SelectOption } from '@src/types';

type Props = {
  lesson?: SllLesson
  skills?: SelectOption[]
};

function OverviewForm(props: Props) {
  const { lesson } = props;

  const [box1, setBox1] = useState<string[]>([]);
  const [helpfulHeading, setHelpfulHeading] = useState('This Lesson is Helpful For Students Who:');
  const [objectAnswers, setObjectAnswers] = useState<string[]>([]);
  const [competency, setCompetency] = useState<string[]>([]);
  const [isCaregiver, setIsCaregiver] = useState(false);

  useEffect(() => {
    if (lesson) {
      setBox1(JSON.parse(lesson?.overviewAnswers1 || '[]'));
      setHelpfulHeading(lesson.overviewHeading1 || 'This Lesson is Helpful For Students Who:');
      setObjectAnswers(JSON.parse(lesson.overviewAnswers2 || '[]'));
      setCompetency(JSON.parse(lesson.competency || '[]'));
      setIsCaregiver(lesson.lessonType === "7")
    }
  }, [lesson])

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.subWrapper}>
          {isCaregiver
          ? <div className={styles.contentView}>
              <div className={styles.header}>
                <div className={styles.subTitle}>
                  {'Learning Objectives:'}
                </div>
              </div>
              <ul className={styles.boxView}>
              {(objectAnswers ?? []).map((o, index) => {
                const optionStr: string = o as string;
                return (
                  <li key={index} className={styles.questionBox}>
                    {optionStr}
                  </li>
                );
              })}
              </ul>
            </div>
          : <div className={styles.contentView}>
            <div className={styles.subContent}>Grade: &nbsp;<span>{lesson?.gradeLevel?.replace('Grade', '')}</span></div>
            <div className={styles.subContent}>Competency: &nbsp;<span>{competency.toString().replace(',', ', ')}</span></div>
            <div className={styles.subContent}>Suggested Time: &nbsp;<span>{lesson?.duration} minutes</span></div>
          </div>}
          <div className={styles.contentView}>
            <div className={styles.header}>
              <div className={styles.subTitle}>
                {isCaregiver ? 'At a Glance:' : helpfulHeading}
              </div>
            </div>
            {isCaregiver ? 
              <ul className={styles.boxView}>
              {(box1 ?? []).map((o, index) => {
                const optionStr: string = o as string;
                return (
                  <li key={index} className={styles.questionBox}>
                    {optionStr}
                  </li>
                );
              })}
              </ul>
            : <div className={styles.tagView}>
            {(box1 ?? []).map((o, index) => {
              const optionStr: string = o as string;
              return (
                <div key={index} className={styles.tagBox}>
                  {optionStr}
                </div>
              );
            })}
            </div>}
          </div>
        </div>
        {!isCaregiver && <div className={styles.subWrapper}>
          <div className={styles.contentView}>
            <div className={styles.header}>
              <div className={styles.subTitle}>
                {'Lesson Objectives:'}
              </div>
            </div>
            <ul className={styles.boxView}>
            {(objectAnswers ?? []).map((o, index) => {
              const optionStr: string = o as string;
              return (
                <li key={index} className={styles.questionBox}>
                  {optionStr}
                </li>
              );
            })}
            </ul>
          </div>
        </div>}
      </div>
    </div>
  );
}

export default OverviewForm;